import React, { useState } from "react";
import { connect } from "react-redux";
import { logout } from "../../app/store/actions/authActions";
import { Menu, Container, Image, Sidebar, Icon } from "semantic-ui-react";
import { Link } from "react-router-dom";
import {
  MENU_CONSULTAS_CONTENT,
  MENU_CONSULTAS_SM_CREDITOS_CONTENT,
  MENU_CONSULTAS_SM_CUENTAS_CONTENT,
  MENU_INICIO_CONTENT,
  MENU_MIS_OFERTAS_CONTENT,
  MENU_MIS_OFERTAS_SM_CAMPANIAS_CONTENT,
  MENU_OPERACIONES_CONTENT,
  MENU_OPERACIONES_SM_APERTURA_CONTENT,
  MENU_OPERACIONES_SM_PAGOS_CONTENT,
  MENU_OPERACIONES_SM_TRANSFERENCIAS_CONTENT,
  // MENU_SEGURIDAD_CLAVE_SMS_CONTENT,
  MENU_SEGURIDAD_SESIONES_CONTENT,
  MENU_SEGURIDAD_LOGOUT_CONTENT,
} from "../../app/infrastructure/appConstants";

const mapState = (state) => ({
  currentUser: state.auth.currentUser,
});

const actions = {
  logout,
};

const UserMenuMovil = ({ currentUser, logout }) => {
  const [showSidebar, handleSidebar] = useState(false);
  const [activeItem, setActiveItem] = useState("inicio");

  return (
    <>
      <Menu fixed="top" secondary size="massive" className="navBarPrymera">
        <Container>
          <Menu.Item header>
            <Image
              src="/assets/images/logo-prymera.svg"
              size="small"
              centered
            />
          </Menu.Item>
          <Menu.Item
            position="right"
            onClick={() => handleSidebar(!showSidebar)}
          >
            <Icon name="sidebar" />
          </Menu.Item>
        </Container>
      </Menu>
      <Sidebar
        as={Menu}
        inverted
        vertical
        visible={showSidebar}
        className="sideBarMenuMovil"
      >
        <Menu.Item
          name="inicio"
          content={MENU_INICIO_CONTENT}
          active={activeItem === "inicio"}
          as={Link}
          to="/inicio"
          onClick={(e, { name }) => {
            handleSidebar(!showSidebar);
            setActiveItem(name);
          }}
        />
        <Menu.Item>
          <Menu.Header>{MENU_MIS_OFERTAS_CONTENT}</Menu.Header>
          <Menu.Menu>
            <Menu.Item
              name="campania"
              content={MENU_MIS_OFERTAS_SM_CAMPANIAS_CONTENT}
              active={activeItem === "campania"}
              as={Link}
              to="/campanias"
              onClick={(e, { name }) => {
                handleSidebar(!showSidebar);
                setActiveItem(name);
              }}
            />
          </Menu.Menu>
        </Menu.Item>

        <Menu.Item>
          <Menu.Header>{MENU_CONSULTAS_CONTENT}</Menu.Header>
          <Menu.Menu>
            <Menu.Item
              name="ofertas"
              content={MENU_CONSULTAS_SM_CREDITOS_CONTENT}
              active={activeItem === "ofertas"}
              as={Link}
              to="/prestamos"
              onClick={(e, { name }) => {
                handleSidebar(!showSidebar);
                setActiveItem(name);
              }}
            />
            <Menu.Item
              name="cuentas"
              content={MENU_CONSULTAS_SM_CUENTAS_CONTENT}
              active={activeItem === "cuentas"}
              as={Link}
              to="/cuentas"
              onClick={(e, { name }) => {
                handleSidebar(!showSidebar);
                setActiveItem(name);
              }}
            />
          </Menu.Menu>
        </Menu.Item>

        <Menu.Item>
          <Menu.Header>{MENU_OPERACIONES_CONTENT}</Menu.Header>
          <Menu.Menu>
            <Menu.Item
              name="pagos"
              content={MENU_OPERACIONES_SM_PAGOS_CONTENT}
              active={activeItem === "pagos"}
              as={Link}
              to="/pagar-prestamos"
              onClick={(e, { name }) => {
                handleSidebar(!showSidebar);
                setActiveItem(name);
              }}
            />
            <Menu.Item
              name="apertura"
              content={MENU_OPERACIONES_SM_APERTURA_CONTENT}
              active={activeItem === "apertura"}
              as={Link}
              to="/aperturar-cuenta"
              onClick={(e, { name }) => {
                handleSidebar(!showSidebar);
                setActiveItem(name);
              }}
            />
            <Menu.Item
              name="transferencias"
              content={MENU_OPERACIONES_SM_TRANSFERENCIAS_CONTENT}
              as={Link}
              to="/transferencias"
              active={activeItem === "transferencias"}
              onClick={(e, { name }) => {
                handleSidebar(!showSidebar);
                setActiveItem(name);
              }}
            />
          </Menu.Menu>
        </Menu.Item>
        <Menu.Item>
          <Menu.Header>
            <Icon name="user outline" />
            {`Hola: ${
              currentUser
                ? currentUser.primerNombre
                  ? currentUser.primerNombre
                  : currentUser.apellidoPaterno
                : ``
            }`}
          </Menu.Header>
          <Menu.Menu>
            {/* <Menu.Item
              name="clavesms"
              active={activeItem === "clavesms"}
              content={MENU_SEGURIDAD_CLAVE_SMS_CONTENT}
              as={Link}
              to="/afiliacion"
              onClick={(e, { name }) => {
                handleSidebar(!showSidebar);
                setActiveItem(name);
              }}
            /> */}
            <Menu.Item
              name="sesiones"
              active={activeItem === "sesiones"}
              content={MENU_SEGURIDAD_SESIONES_CONTENT}
              icon="laptop"
              as={Link}
              to="/sesiones"
              onClick={(e, { name }) => {
                handleSidebar(!showSidebar);
                setActiveItem(name);
              }}
            />
            <Menu.Item
              content={MENU_SEGURIDAD_LOGOUT_CONTENT}
              icon="log out"
              onClick={logout}
            />
          </Menu.Menu>
        </Menu.Item>
      </Sidebar>
    </>
  );
};

export default connect(mapState, actions)(UserMenuMovil);
